import React from 'react';

function RecommendedAction(props) {
    const message = props.data.message;
    const code = props.data.code;

    let _class = '';
    if (code < 0) {
        _class = 'red';
    } else if (code === 0) {
        _class = 'blue';
    } else {
        _class = 'green';
    }

    return (
        <>
            <div className="recommended-action-container">
                <h4 className={`${_class}`}>{message}</h4>
            </div>
        </>
    );
}

export default RecommendedAction;
